export default __webpack_public_path__ + "static/media/ipadFrame.aa1ab621.png";